import React from 'react';

import { BulletList, LoginButton } from 'features/order-tracker/shared-components';

import { LOGIN_BENEFITS } from './constants';

import styles from './styles.module.scss';

export const LoginBenefitsBlock: React.FC<components.LoginBenefitsBlock> = ({ title }) => (
  <div className={styles.benefitsBlockContainer}>
    <BulletList title={title} list={LOGIN_BENEFITS} />
    <LoginButton target="_blank" className={styles.loginButton} />
  </div>
);
